import {
    Processor,
    ValueObj
} from "@xapp/stentor-api-client/dist/services/rest/fetch/FetchHTTPClient";

/**
 * A generator which creates a processor which will
 * automatically append all values to the given object.
 *
 * @export
 * @param {ValueObj} params
 * @returns {Processor<ValueObj>}
 */
export function addParameters<Original extends ValueObj = ValueObj, Add extends ValueObj = ValueObj>(params: Add = {} as Add): Processor<Original & Add> {
    return (obj) => ({ ...obj, ...params });
}
